import React, { useContext, useState, useReducer } from 'react';
import styled from 'styled-components';
import context from '../../context/property';
import officeContext from '../../context';
import { LoadingOutlined, CheckCircleFilled, WhatsAppOutlined, MailOutlined, PhoneOutlined } from '@ant-design/icons';

import { Section } from '../../styled-components';
import { Input, Textarea } from '../inputs';
import { Button } from '../../styled-components';

const SectionCustom = styled(Section)`
  background-color: #fff;
  padding: 2rem;
  border: 1px solid #ebebeb;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const Title = styled.h2`
  color: #4C5C75;
  font-size: 1.8rem;
  font-family: 'Raleway', sans-serif !important;
  font-weight: 600;
`;

const UserCont = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  margin: 2rem 0;
  padding: 1rem;
  background: #fff;
  border-radius: 12px;
`;

const Avatar = styled.img`
  height: 80px;
  width: 80px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid #AEE8F8;
`;

const UserInfoCont = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  font-family: 'Raleway', sans-serif !important;
  font-size: 0.9rem;
  color: #3C3C3C;
`;

const UserName = styled.li`
  font-weight: bold;
  font-size: 1rem;
  font-family: 'Raleway', sans-serif !important;
  color: #2A3E55;
  margin-bottom: 0.3rem;
`;

const UserPosition = styled.span`
  font-weight: normal;
  font-size: 0.85rem;
  color: #7089A1;
`;

const ContactDetail = styled.li`
  display: flex;
  align-items: center;
  font-size: 0.85rem;
  color: #5F738A;
  margin-bottom: 0.2rem;
  svg {
    margin-right: 0.5rem;
    color: #A4B1C2;
  }
`;

const Form = styled.form``;

const SuccessText = styled.p`
  margin-top: 1rem;
  font-size: 0.9rem;
  color: #28a745;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const IconButton = styled.a`
  color: #6F7C99;
  transition: 250ms ease;
  display: flex;
  align-items: center;
  margin-top: 2rem;
  font-size: 0.9rem;
  cursor: pointer;
  &:hover {
    color: #25D366;
  }
`;

export default () => {
  const state = useContext(context);
  const officeState = useContext(officeContext);
  const user = { ...state._comercialUser[0], ...state._comercialUser_person[0] };
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [values, setValues] = useReducer((current, next) => ({ ...current, ...next }), {
    name: "",
    email: "",
    mobile: "",
    message: `Hola ${state._office[0].name}, Estoy interesado en COD: ${state.code}, por favor comunícate conmigo. ¡Gracias!`,
  });

  const handleChange = (e) => {
    setValues({ [e.target.id]: e.target.value });
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const options = {
        headers: { "Content-type": "application/json" },
        method: "POST",
        body: JSON.stringify({
          ...values,
          nameAgent: `${user.firstName} ${user.lastName}`,
          emailAgent: user.email,
        }),
        mode: "cors",
      };

      const data = await fetch("/sendmail.php", options);
      const result = await data.text();

      if (result === "success") {
        setLoading(false);
        setSuccess(true);
        setTimeout(() => setSuccess(false), 5000);
      }
      setLoading(false);

      setValues({ name: '', mobile: '', email: '', message: '' });
    } catch (e) {
      setLoading(false);
      console.log("error", e);
    }
  };

  return (
    <SectionCustom>
      <div>
        <Title>Contacto</Title>
        <UserCont>
          <Avatar
            src="https://pmasesoriasinmobiliarias.cl/favicon-32x32.png?v=3855c7f4a5680ff6d12e4f461b043ee4"
            alt="Avatar"
          />
          <UserInfoCont>
            <UserName>
              {user.firstName + " " + user.lastName}
              {user.position && <UserPosition> — {user.position}</UserPosition>}
            </UserName>
            {user.phone && (
              <ContactDetail>
                <PhoneOutlined />
                {`${user.phone.countryCode} ${user.phone.areaCode} ${user.phone.phoneNumber}`}
              </ContactDetail>
            )}
            {user.mobile && (
              <ContactDetail>
                <WhatsAppOutlined />
                {`${user.mobile.countryCode} ${user.mobile.areaCode} ${user.mobile.phoneNumber}`}
              </ContactDetail>
            )}
            {user.email && (
              <ContactDetail>
                <MailOutlined />
                {user.email}
              </ContactDetail>
            )}
          </UserInfoCont>
        </UserCont>
        <Form onSubmit={onSubmit}>
          <Input placeholder="Nombre" gray withMargin disabled={loading} id="name" onChange={handleChange} value={values.name} />
          <Input placeholder="Email" gray withMargin disabled={loading} id="email" onChange={handleChange} value={values.email} />
          <Input placeholder="Teléfono" gray withMargin disabled={loading} id="mobile" onChange={handleChange} value={values.mobile} />
          <Textarea rows="6" placeholder="Mensaje" gray disabled={loading} id="message" onChange={handleChange} value={values.message} />
          <br /><br />
          <Button primary block disabled={loading}>
            Enviar {loading && <LoadingOutlined style={{ marginLeft: "1rem" }} />}
          </Button>
          {success && <SuccessText>Su mensaje fue enviado con éxito <CheckCircleFilled style={{ marginLeft: ".3rem" }} /></SuccessText>}
        </Form>
      </div>
      <div>
        <IconButton href={`https://api.whatsapp.com/send?phone=${officeState.phone}&text=${values.message}`} alt="send whatsapp message">
          <WhatsAppOutlined style={{ marginRight: 8, fontSize: "2rem" }} />
          <span>¿Deseas contactarme por teléfono o enviarme un WhatsApp?</span>
        </IconButton>
      </div>
    </SectionCustom>
  );
};